<div *ngFor="let cardDetails of cardConfig">
    <mat-card class="example-card">
        <mat-card-title> {{ cardDetails.title }} </mat-card-title>
        <mat-card-subtitle>{{ cardDetails.subTitle }}</mat-card-subtitle>
        <mat-card-content>
          <ul *ngFor='let details of cardDetails.content'>
              <li>{{ details }}</li>
          </ul>
        </mat-card-content>
        <mat-card-actions *ngIf=cardDetails.actions != null>
          <button mat-button>LIKE</button>
          <button mat-button>SHARE</button>
        </mat-card-actions>
    </mat-card>

</div>
